import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-139ea18e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info__title" }
const _hoisted_3 = { class: "info__text" }
const _hoisted_4 = { class: "info__text info__list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CNAME", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "info__text_inline" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "{", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "}", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info__text_inline" }, [
  /*#__PURE__*/_createElementVNode("b", null, "traff.masons.partners")
], -1))
const _hoisted_12 = {
  style: {"margin-top":"12px"},
  class: "info__text"
}
const _hoisted_13 = {
  style: {"margin":"12px 0px 0px 0px"},
  class: "info__text"
}
const _hoisted_14 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AddDomainDialog = _resolveComponent("AddDomainDialog")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "dashboard__page info__page" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('pages.instruction.title')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('pages.instruction.subTitle')) + ":", 1),
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('pages.instruction.step1')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('pages.instruction.step2')), 1),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('pages.instruction.step3')) + " ", 1),
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('pages.instruction.ask')) + ":", 1)
            ]),
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("b", null, [
                _createTextVNode("*."),
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.$t('pages.instruction.step4')), 1),
                _hoisted_9
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages.instruction.step5')) + ":", 1),
            _hoisted_10,
            _hoisted_11
          ]),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('pages.instruction.step6')), 1)
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('pages.instruction.step7')), 1),
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('pages.instruction.step8')), 1),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_q_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddDomainDialog = !_ctx.showAddDomainDialog)),
            outline: "",
            "no-caps": "",
            label: _ctx.$t('pages.instruction.add'),
            color: "primary",
            style: {"margin-top":"16px","width":"100%","max-width":"250px","border-color":"#EDB94A","padding-top":"12px","padding-bottom":"12px"},
            class: "balances__btn",
            icon: "add"
          }, null, 8, ["label"])
        ])
      ]),
      _createVNode(_component_AddDomainDialog, {
        open: _ctx.showAddDomainDialog,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddDomainDialog = false)),
        onRefresh: _ctx.onRequest
      }, null, 8, ["open", "onRefresh"]),
      _createVNode(_component_q_table, {
        dark: "",
        dense: "",
        rows: _ctx.rows,
        columns: _ctx.createColumns,
        "row-key": "id",
        separator: "cell",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
        loading: _ctx.loading,
        onRequest: _ctx.onRequest,
        "binary-state-sort": "",
        class: "table-with-min-height-row",
        style: {"height":"max-content"}
      }, null, 8, ["rows", "columns", "pagination", "loading", "onRequest"])
    ]),
    _: 1
  }))
}